import React from "react";
import { Link, withRouter } from 'react-router-dom'
import Aux from "../AuxFunctions";
import "./SideBar.css"
import ChevronRightIcon from "mdi-react/ChevronRightIcon"
import { withMyDataContext } from "../../context/DataProvider";
import PlusIcon from "mdi-react/PlusIcon"
import SearchIcon from "mdi-react/SearchIcon"
import SettingsIcon from "mdi-react/SettingsIcon"
import Colors from "../Colors";
import NotLoggedIn from "../ErrorPages/NotLoggedIn";
import Loader from "../Utilities/Loader";

class SideMenuMobile extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      showMore: false,
      openModal: false,
    }
  }

  handleClick = () => {
    this.setState((prevState) => ({ showMore: !prevState.showMore }));
  }


  handleNotLoggedin = () => {
    this.setState({ openModal: true })
  }

  goToCoins = () => {
    try{
        this.props.closeSidebar()
        this.props.history.push("/account/balance")
    }catch(error){
        Aux.handleError(error)
    }
  }

  HashtagRender = () => {
    return (
    <div style={{marginTop:10}} >
         {/* <span className="cat-title-text cat-item-menu" style={{ paddingTop: 18 }}>Hashtags</span> 
        <div className="cat-underline"></div> */}
        <Link onClick={this.props.closeSidebar} className={ !this.props.myDataProvider.currentHashtag ? "cat-single-item-menu cat-menu-active" :"cat-single-item-menu"} to={"/"} >
            <div style={{ display: "flex", alignItems: "center" }}>
                <span>#all</span>
            </div>
            {/* <ChevronRightIcon style={{ color: Colors.softText }}></ChevronRightIcon> */}
        </Link>
        
        {this.props.myDataProvider.loadingTags ? <Loader></Loader>
        :
        this.props.myDataProvider.tags.map((item, i) => (
            <Link onClick={this.props.closeSidebar} key={i} style={{marginRight:10}} className={ this.props.myDataProvider.currentHashtag === item.hashtag ? "cat-single-item-menu cat-menu-active" :"cat-single-item-menu"} to={item.hashtag === "" ? "/" : "/hashtag/" + item.hashtag} >
            <div style={{ display: "flex", alignItems: "center", overflow:"hidden" }}>
                <span style={{textOverflow:"ellipsis", overflow:"hidden"}}>#{item.hashtag}</span> {item.coins ? <span>({item.coins}$)</span> : null}
            </div>
            </Link>
        ))}

        </div>
    );
  }


  balanceRender = () => {
    return (
      <div >
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <span className="cat-title-text cat-item-menu">Balance</span>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end" }}>

            <span className="cat-item-text" style={{ marginRight: 5 }}>{this.props.myDataProvider.coins || 0}$</span>
            <PlusIcon onClick={this.goToCoins} className="button-hover" style={{ backgroundColor: Colors.mainColor, color: "white", borderRadius: 50, marginRight: 30 }}></PlusIcon>
          </div>
        </div>
        <div className="cat-underline"></div>
      </div>
    )
  }

  profileRender = () => {
    return (
      <div >
        <Link onClick={this.props.closeSidebar}  to={"/account/profile"} style={{textDecoration:"none", display: "flex", margin:15, padding: "4px 10px", alignItems:"center", cursor:"pointer", color:"#444"}} >
          {Aux.showAvatar(50, this.props.myDataProvider.user.avatar, this.props.myDataProvider.user.username || "unknown")}
          <h4 style={{marginLeft:10, textOverflow:"ellipsis", overflow:"hidden"}}>@{this.props.myDataProvider.user.username || "unknown"}</h4>
        </Link>
        <Link onClick={this.props.closeSidebar}  className="cat-item-menu" to={"/account/profile"} >
          <div style={{ display: "flex", alignItems: "center" }}>
            <span>My Profile</span>
          </div>
          <ChevronRightIcon style={{ color: "#ccc" }}></ChevronRightIcon>
        </Link>
        <Link onClick={this.props.closeSidebar}  className="cat-item-menu" to={"/account/achievements"} >
          <div style={{ display: "flex", alignItems: "center" }}>
            <span>{"Earn & Achievements"}</span>
          </div>
          <ChevronRightIcon style={{ color: "#ccc" }}></ChevronRightIcon>
        </Link>
        <Link onClick={this.props.closeSidebar}  className="cat-item-menu" to={"/account/daily"} >
          <div style={{ display: "flex", alignItems: "center" }}>
            <span>Daily Rewards</span>
          </div>
          <ChevronRightIcon style={{ color: "#ccc" }}></ChevronRightIcon>
        </Link>
        <Link onClick={this.props.closeSidebar}  className="cat-item-menu" to={"/account/invitefriends"} >
          <div style={{ display: "flex", alignItems: "center" }}>
            <span>Invite Friends</span>
          </div>
          <ChevronRightIcon style={{ color: "#ccc" }}></ChevronRightIcon>
        </Link>
      </div>
    )
  }

  toggleModal = () => {
    this.setState({
      openModal: !this.state.openModal
    });
  }

  render() {
    return (
      <div style={{ backgroundColor: "white", overflowX: "hidden", width:265}}>
        <NotLoggedIn active={this.state.openModal} onClose={this.toggleModal}></NotLoggedIn>
        {this.props.myDataProvider.user ? 
        <div>
          <this.balanceRender ></this.balanceRender>
          <this.profileRender></this.profileRender>
        </div>
          :
          null
        }
        <Link onClick={this.props.closeSidebar} className="cat-single-item-menu" to={"/settings"}  style={{marginRight:10}}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <span>Settings</span>
          </div>
          <SettingsIcon style={{ color: "#ccc" }}></SettingsIcon>
        </Link>
        <Link onClick={this.props.closeSidebar} className="cat-single-item-menu" to={"/search"} style={{marginRight:10}}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <span>Search</span>
          </div>
          <SearchIcon style={{ color: "#ccc" }}></SearchIcon>
        </Link>
         <div className="cat-underline"></div> 
        <this.HashtagRender></this.HashtagRender>
      </div>
    );
  };
}
export default withMyDataContext(withRouter(SideMenuMobile));